// eslint-disable-next-line no-redeclare,no-unused-vars
function registerList(element, key) {
  if (!elements.lists[key + '_els']) elements.lists[key + '_els'] = [];
  $.each(elements.lists[key + '_els'], function (i, el) {
    if (el && !$.contains(document.body, el[0]))
      delete elements.lists[key + '_els'][i];
  });
  elements.lists[key + '_els'].push(element);
}
